var _circle, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWentwrong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 226,
    viewBox: "0 0 227 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 113,
    r: 113,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1523 117.49H68.517V154.048C68.517 157.245 65.9255 159.836 62.7288 159.836C56.3353 159.836 51.1523 154.653 51.1523 148.26V117.49Z",
    fill: "#3D7DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.235 50.0293V144.634C154.235 153.027 147.41 159.835 138.995 159.835H63.8779V159.721C66.5242 159.188 68.517 156.85 68.517 154.047V117.489V50.0293H102.227L99.8405 59.176L105.806 65.917L102.227 78.606L111.771 94.0707L105.806 78.606L109.638 65.3582L104.056 59.176L106.73 50.0293H154.235Z",
    fill: "#D0D6D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32346_434987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.46 165.961C145.216 165.961 160.42 150.751 160.42 131.988C160.42 113.226 145.216 98.0156 126.46 98.0156C107.704 98.0156 92.5 113.226 92.5 131.988C92.5 150.751 107.704 165.961 126.46 165.961Z",
    fill: "#3D7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.46 159.762C141.793 159.762 154.223 147.327 154.223 131.988C154.223 116.65 141.793 104.215 126.46 104.215C111.127 104.215 98.6968 116.65 98.6968 131.988C98.6968 147.327 111.127 159.762 126.46 159.762Z",
    fill: "#F7FAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.977 107.217C126.022 110.262 123.724 117.495 117.845 123.374C111.966 129.253 104.733 131.551 101.688 128.507C98.6438 125.462 100.942 118.228 106.82 112.35C112.699 106.471 119.933 104.173 122.977 107.217Z",
    fill: "url(#paint0_linear_32346_434987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.942 156.759C126.897 153.715 129.195 146.481 135.074 140.602C140.953 134.723 148.186 132.426 151.231 135.47C154.275 138.514 151.977 145.748 146.099 151.627C140.22 157.506 132.986 159.804 129.942 156.759Z",
    fill: "url(#paint1_linear_32346_434987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.642 147.578L162.196 151.769L158.404 156.778L153.057 153.145C153.057 153.145 155.51 149.946 156.642 147.578Z",
    fill: "#FFAF21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.918 149.436L156.921 158.769L181.551 175.015C184.127 176.722 187.591 176.077 189.401 173.587C191.316 170.941 190.655 167.214 187.922 165.403L163.918 149.436Z",
    fill: "#3D7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.151 161.572L168.235 152.309",
    stroke: "#FFAF21",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.352 116.42H130.585V122.741L129.001 135.452H123.901L122.352 122.741V116.42ZM122.631 137.385H130.324V144.194H122.631V137.385Z",
    fill: "#141C1A"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1519 67.0059C52.6167 68.0712 53.1503 68.7527 53.9019 70.2559",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.496 124.064C190.556 121.645 192.996 122.534 192.996 120.064",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.05 84.7969C168.581 85.416 168.046 85.7844 168.3 86.5469",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.842 183.895C115.35 183.197 115.842 182.73 115.842 181.895C115.842 181.452 115.69 180.846 116.092 180.645",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0039 122.939C34.8342 122.244 34.6566 121.516 34.0039 121.189",
    stroke: "#DFE5E4",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32346_434987",
    x: 88.5,
    y: 98.0156,
    width: 105.996,
    height: 87.9551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32346_434987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32346_434987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32346_434987",
    x1: 99.8239,
    y1: 105.353,
    x2: 112.67,
    y2: 117.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32346_434987",
    x1: 153.095,
    y1: 158.624,
    x2: 140.248,
    y2: 146.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWentwrong);
export default __webpack_public_path__ + "static/media/wentwrong.f16dbf444fbc261d55342db4f2f60f4b.svg";
export { ForwardRef as ReactComponent };